import React, { useState } from 'react';

function RoomFilters({ rooms, onFilterChange }) {
  const [filters, setFilters] = useState({
    status: 'all',
    floor: 'all',
    type: 'all',
    search: ''
  });

  // Extraire les valeurs uniques pour les filtres
  const uniqueFloors = [...new Set(rooms.map(room => room.floor))].sort();
  const uniqueTypes = [...new Set(rooms.map(room => room.type))];

  const statusOptions = [
    { value: 'all', label: 'Tous les statuts', count: rooms.length },
    { value: 'available', label: 'Libre', count: rooms.filter(r => r.status === 'available').length },
    { value: 'occupied', label: 'Occupée', count: rooms.filter(r => r.status === 'occupied').length },
    { value: 'reserved', label: 'Réservée', count: rooms.filter(r => r.status === 'reserved').length },
    { value: 'maintenance', label: 'Maintenance', count: rooms.filter(r => r.status === 'maintenance').length }
  ];

  const handleFilterChange = (filterType, value) => {
    const newFilters = { ...filters, [filterType]: value };
    setFilters(newFilters);

    // Appliquer les filtres
    let filteredRooms = rooms;

    // Filtre par statut
    if (newFilters.status !== 'all') {
      filteredRooms = filteredRooms.filter(room => room.status === newFilters.status);
    }

    // Filtre par étage
    if (newFilters.floor !== 'all') {
      filteredRooms = filteredRooms.filter(room => room.floor.toString() === newFilters.floor);
    }

    // Filtre par type
    if (newFilters.type !== 'all') {
      filteredRooms = filteredRooms.filter(room => room.type === newFilters.type);
    }

    // Filtre par recherche
    if (newFilters.search.trim()) {
      const searchTerm = newFilters.search.toLowerCase();
      filteredRooms = filteredRooms.filter(room =>
        room.room_number.toLowerCase().includes(searchTerm) ||
        room.guest_name?.toLowerCase().includes(searchTerm) ||
        room.type.toLowerCase().includes(searchTerm)
      );
    }

    onFilterChange(filteredRooms, newFilters);
  };

  const clearFilters = () => {
    const defaultFilters = { status: 'all', floor: 'all', type: 'all', search: '' };
    setFilters(defaultFilters);
    onFilterChange(rooms, defaultFilters);
  };

  const getActiveFiltersCount = () => {
    let count = 0;
    if (filters.status !== 'all') count++;
    if (filters.floor !== 'all') count++;
    if (filters.type !== 'all') count++;
    if (filters.search.trim()) count++;
    return count;
  };

  const activeFiltersCount = getActiveFiltersCount();

  return (
    <div className="room-filters">
      <div className="filters-header">
        <div className="filters-left">
          <h3>🏨 Gestion des Chambres</h3>
          <div className="results-info">
            <span className="room-count">{rooms.length} chambres</span>
            {activeFiltersCount > 0 && (
              <span className="filter-badge">
                {activeFiltersCount} filtre{activeFiltersCount > 1 ? 's' : ''} actif{activeFiltersCount > 1 ? 's' : ''}
              </span>
            )}
          </div>
        </div>

        <div className="filters-right">
        </div>
      </div>

      <div className="filters-content">
          <div className="filters-row">
            {/* Recherche */}
            <div className="filter-group search-group">
              <label>Rechercher</label>
              <input
                type="text"
                placeholder="N° chambre, client, type..."
                value={filters.search}
                onChange={(e) => handleFilterChange('search', e.target.value)}
                className="search-input"
              />
            </div>

            {/* Filtre statut */}
            <div className="filter-group">
              <label>Statut</label>
              <select
                value={filters.status}
                onChange={(e) => handleFilterChange('status', e.target.value)}
                className="filter-select"
              >
                {statusOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label} ({option.count})
                  </option>
                ))}
              </select>
            </div>

            {/* Filtre étage */}
            <div className="filter-group">
              <label>Étage</label>
              <select
                value={filters.floor}
                onChange={(e) => handleFilterChange('floor', e.target.value)}
                className="filter-select"
              >
                <option value="all">Tous les étages</option>
                {uniqueFloors.map(floor => (
                  <option key={floor} value={floor.toString()}>
                    Étage {floor} ({rooms.filter(r => r.floor === floor).length})
                  </option>
                ))}
              </select>
            </div>

            {/* Filtre type */}
            <div className="filter-group">
              <label>Type</label>
              <select
                value={filters.type}
                onChange={(e) => handleFilterChange('type', e.target.value)}
                className="filter-select"
              >
                <option value="all">Tous les types</option>
                {uniqueTypes.map(type => (
                  <option key={type} value={type}>
                    {type.charAt(0).toUpperCase() + type.slice(1)} ({rooms.filter(r => r.type === type).length})
                  </option>
                ))}
              </select>
            </div>

            <div className="filter-actions">
              <button
                className="btn"
                onClick={clearFilters}
                title="Réinitialiser tous les filtres"
              >
                X
              </button>
            </div>
          </div>

          {/* Filtres rapides */}
          <div className="quick-filters">
            <span className="quick-label">Filtres rapides :</span>
            {statusOptions.slice(1).map(option => (
              <button
                key={option.value}
                onClick={() => handleFilterChange('status', option.value)}
                className={`quick-filter ${filters.status === option.value ? 'active' : ''}`}
                disabled={option.count === 0}
              >
                {option.label} ({option.count})
              </button>
            ))}
          </div>
        </div>
    </div>
  );
}

export default RoomFilters;